<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraph1">
<p class="noindent"><a id="page-ix"></a><em>We know many things about those we love—things we nevertheless refuse to believe.</em></p>
<p class="attribution1">—E<span class="small-caps">LIAS</span> C<span class="small-caps">ANETTI</span></p>
</div>
<div class="epigraph">
<p class="noindent"><em>Mother is the best bet and don’t let Satan draw you too fast.</em></p>
<p class="attribution1">—D<span class="small-caps">UTCH</span> S<span class="small-caps">CHULTZ</span>, on his deathbed</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?7a0b7a3d